function MainCard(props) {
    return (
        <div className="p-3">
            <div className="surface-panel pb-3">

                {/* Header */}
                <div className="px-6 py-4 border-b border-border">
                    <div className="flex items-center justify-between gap-3">
                        <h2 className="font-display text-xl font-semibold text-foreground flex items-center gap-2.5">
                            {props.icon && <i className={`${props.icon} text-primary`} />}
                            {props.title}
                        </h2>
                        <div>
                            {props.header}
                        </div>
                    </div>
                </div>
                {props.children}
            </div>
        </div>
    )
}

export default MainCard;